const HeaderRoutes = [
  {
    name: "Career",
    routeName: "/career",
  },
  {
    name: "Skills",
    routeName: "/skills",
  },
  {
    name: "Contact",
    routeName: "/contact",
  },
];

export default HeaderRoutes;
